import { GOOGLE_ADS_CAMPAIGN_STATUS } from '../../../../../../../services/exports/Constants';

export default {
  buttons: {
    back: 'Wstecz',
  },
  metrics: {
    impressions: {
      label: 'Wyświetlenia',
      description: 'Liczba wyświetleń reklamy w wynikach wyszukiwania Google lub w witrynach partnerów.',
    },
    clicks: {
      label: 'Kliknięcia',
      description: 'Liczba kliknięć reklamy przez użytkowników.',
    },
    budget_spent: {
      label: 'Wydatki na budżet',
      description: 'Łączna kwota wydana na tę kampanię.',
    },
    absolute_top_impression_percentage: {
      label: '% wyświetleń na absolutnym szczycie',
      description: 'Odsetek przypadków, gdy reklama pojawiła się na samym szczycie wyników Google.',
    },
    phone_calls: {
      label: 'Połączenia',
      description: 'Łączna liczba połączeń telefonicznych z reklamy.',
    },
    phone_impressions: {
      label: 'Wyświetlenia numeru telefonu',
      description: 'Liczba wyświetleń numeru telefonu w reklamie.',
    },
    phone_through_rate: {
      label: 'Wskaźnik połączeń telefonicznych',
      description: 'Odsetek wyświetleń numeru skutkujących połączeniem (Połączenia ÷ Wyświetlenia numeru).',
    },
    directions: {
      label: 'Trasy dojazdu',
      description: 'Liczba kliknięć w celu uzyskania trasy do lokalizacji firmy.',
    },
    daily_budget: {
      label: 'Dzienny budżet',
      description: 'Maksymalna kwota przeznaczona dziennie na tę kampanię.',
    },
    status: {
      label: 'Status',
      description: 'Aktualny stan kampanii.',
    },
    ctr: {
      label: 'Współczynnik klikalności',
      description: 'Odsetek wyświetleń reklamy skutkujących kliknięciem (Kliknięcia ÷ Wyświetlenia).',
    },
    average_cpc: {
      label: 'Średni koszt kliknięcia',
      description: 'Średnia kwota płacona za każde kliknięcie reklamy (Koszt całkowity ÷ Kliknięcia).',
    },
    conversions_from_interactions_rate: {
      label: 'Współczynnik konwersji',
      description: 'Odsetek interakcji z reklamą prowadzących do konwersji.',
    },
    start_date: {
      label: 'Data rozpoczęcia',
      description: 'Data rozpoczęcia kampanii.',
    },
    sales_from_google_ads: {
      label: 'Sprzedaż z Google Ads',
      description: 'Łączna kwota wygenerowana przez Google Ads.',
    },
  },
  status: {
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNSPECIFIED]: 'Nie określono',
    [GOOGLE_ADS_CAMPAIGN_STATUS.ENABLED]: 'Włączona',
    [GOOGLE_ADS_CAMPAIGN_STATUS.PAUSED]: 'Wstrzymana',
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNKNOWN]: 'Nieznany',
    [GOOGLE_ADS_CAMPAIGN_STATUS.REMOVED]: 'Usunięta',
  },
  error_messages: {
    loading_failed: 'Nie udało się załadować szczegółów kampanii. Spróbuj ponownie.',
  },
};
